import {Component, Input, OnInit, Output} from '@angular/core';
import {LineItem} from '@app/core/model/Usage';

@Component({
  selector: 'app-line-items',
  templateUrl: './line-items.component.html'
})
export class LineItemsComponent {
  @Input() header: string;
  @Input() lineItems: LineItem[];
}

